import type { AnalyticsModel } from '@flocasts/experience-service-types'

export const getAnalytics = (
  isPremium: boolean,
  nodeId: number,
  nodeType: string,
  name: string,
  primaryAssociationId: number | null,
  primaryAssociationTitle: string | null
): AnalyticsModel => {
  return {
    type: 'analytics',
    isPremium,
    siteId: null,
    siteName: null,
    nodeId,
    nodeType,
    primaryAssociationId,
    primaryAssociationTitle,
    collectionSlug: null,
    entityId: null,
    entityType: null,
    name,
    extraContext: null,
    primaryAssociationShortTitle: null,
    slugUri: null,
    videoAnalytics: null
  }
}

export const getQueryParamFromLinkModelUrl = (linkModelUrl: string, queryParam: string): string | null => {
  const paramsString = linkModelUrl.replace(/.*?\?/, '')
  const queryParams = new URLSearchParams(paramsString)

  return queryParams.get(queryParam)
}
/**
 * Strips the limit and offset off of LinkModel url
 * and calculates which page increment the user is on
 * for Segment track calls
 * ex: offset 0, limit 10  { page: 1 }
 * ex: offset 10, limit 10 { page: 2 }
 *
 * @param linkModelUrl string
 * ex: /api/experiences/web/event-hub/7417640/results?version=1.7.82&limit=10&offset=10...
 */
export const getInfiniteScrollSegmentProps = (linkModelUrl: string | undefined): { page: number } | null => {
  if (!linkModelUrl) {
    return null
  }

  const offset = getQueryParamFromLinkModelUrl(linkModelUrl, 'offset')
  const limit = getQueryParamFromLinkModelUrl(linkModelUrl, 'limit')

  return !!(offset && limit) ? { page: Number(offset) / Number(limit) + 1 } : null
}
